
import React from "react";
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { SermonPlan } from "@/hooks/sermon-plans/types";

interface FormActionButtonsProps {
  currentSermonPlan: SermonPlan | null;
  onCancel: () => void;
}

export function FormActionButtons({ currentSermonPlan, onCancel }: FormActionButtonsProps) {
  return (
    <DialogFooter className="px-6 py-4 mt-auto border-t flex flex-col sm:flex-row gap-2">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        className="w-full sm:w-auto"
      >
        Cancel
      </Button>
      <Button 
        type="submit"
        className="w-full sm:w-auto"
      >
        {currentSermonPlan ? "Update Sermon Plan" : "Create Sermon Plan"}
      </Button>
    </DialogFooter>
  );
}
